// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"223":"5f891be4","275":"00ac9e84","421":"427508c8","655":"a75bea45","719":"d336f102","942":"011c2ea0"}[chunkId] + ".js";
};